import React from 'react'
import { DrawerModal, Modal, modalVisibility, ModalVisibilityProps, openModal } from 'sb-modal'
import { useMedia, useMemo } from 'sb-hooks'
import { links } from 'common/helpers'

import { Box } from 'components/_new/layout'
import Link from 'components/_new/typography/Link/Link'

import messages from './messages'


const ReviewThankYouModal: React.FunctionComponent<Review.ReviewThankYouModalProps & ModalVisibilityProps> = (props) => {
  const { isMobile } = useMedia()
  const { productId, rating, closeModal, onClose } = props

  const isPositive = rating >= 4
  const moodMessages = isPositive ? messages.positive : messages.negative

  const buttonProps = useMemo(() => ({
    title: moodMessages.buttonTitle,
    to: `${links.recommendations.root}?reviewedProductId=${productId}`,
    rightIcon: 'rightArrowSmall',
    noPadding: true,
    onClick: () => {
      closeModal()
    },
  }), [ closeModal, moodMessages, productId ])

  if (isMobile) {
    return (
      <DrawerModal
        iconName="glad"
        title={messages.title}
        text={moodMessages.text}
        onClose={onClose}
      >
        <Box mt={16}>
          <Link
            message={buttonProps.title}
            to={buttonProps.to}
            color="brand"
            semibold
            withArrow
            withUnderline={false}
            onClick={buttonProps.onClick}
          />
        </Box>
      </DrawerModal>
    )
  }

  return (
    <Modal
      iconName="glad"
      title={messages.title}
      text={moodMessages.text}
      primaryButton={buttonProps}
      onClose={onClose}
    />
  )
}


export const openReviewThankYouModal = (props: Review.ReviewThankYouModalProps) =>
  openModal('reviewThankYou', props)


export default modalVisibility('reviewThankYou', ReviewThankYouModal)
